import * as types from 'Actions/types'
import { createAction } from 'Utils/redux'

export const addLookups = createAction(types.CACHE_ADD_LOOKUPS, 'data')
export const loadLookups = createAction(types.CACHE_LOAD_LOOKUPS)
